module.exports = __webpack_public_path__ + "static/Carly_Daniel5-960085e8e246640c25a2663831752a6c.jpg";